<template>
  <div>
    <el-tooltip class="item" effect="dark" placement="top-start" :disabled="info.q_tips === null || !info.q_tips" :enterable="false">
      <p class="question__desc" v-html="info.q_tips" slot="content" ></p>
      <div class="question__itemTitle">
        <span class="req" v-show="info.q_is_required === 1">*</span>
        <span v-if="HideNumber !== 1">{{info.q_number}}.</span>
        <span :style="{color: info.q_color}">{{info.q_title}}</span>
      </div>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  name: 'BaseContent',
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    },
    HideNumber: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
